import { Outlet } from 'react-router';

export default function Account() {
  return (
    <Outlet />
  );
}
